import config from '@/config'
import { IApi } from '@/contracts/core/api/interface/IApi'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import { ApiV1 } from '@/core/api/v1/ApiV1'

const version = config.api.version

class ApiProvider extends Provider<IApi> {
  realizations: Record<string, IApi> = {
    v1: new ApiV1(),
  }

  version(): string {
    return version
  }

  path(): string {
    throw new Error('Method not implemented.')
  }

  module(): IApi {
    const mod = this.realizations[version]
    if (!mod) {
      throw new Error('Unknown IApi version: ' + version)
    }
    return mod
  }
}

const instance: { module: IApi | null } = { module: null }

export function ApiProviderModule(): IApi {
  if (!instance.module) {
    instance.module = new ApiProvider().module()
  }

  return instance.module
}
